import { render, staticRenderFns } from "./Funny404.vue?vue&type=template&id=0da1184f&"
import script from "./Funny404.vue?vue&type=script&lang=js&"
export * from "./Funny404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports